import _defineProperty from 'babel-runtime/helpers/defineProperty';
import 'antd/es/empty/style';
import _Empty from 'antd/es/empty';
import 'antd/es/tag/style';
import _Tag from 'antd/es/tag';
import _extends from 'babel-runtime/helpers/extends';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import 'antd/es/popover/style';
import _Popover from 'antd/es/popover';
import 'antd/es/badge/style';
import _Badge from 'antd/es/badge';
import 'antd/es/tabs/style';
import _Tabs from 'antd/es/tabs';

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useState, useEffect } from 'react';
// import { BellOutlined } from "@ant-design/icons";
import cx from 'classnames';

import { Link } from 'react-router-dom';
import { dyDomainCity, dyDomainNy } from '../utils/constant';
import msgImg from '../assets/msg.png';
import './NavMsg.css';

var TabPane = _Tabs.TabPane;

/**
 * 时间格式2020-02-11T12:24:18.000+0000转化成正常格式
 * @param {*日期} date
 */

var renderTime = function renderTime(date) {
  var dateee = new Date(date).toJSON();
  return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
};

/**
 * 导航栏图标
 * @noticNum {*记录所有未读信息总数} noticNum
 * @getNotice {*获取未读信息总数的方法} getNotice
 *
 * @token {*用户token} token
 * @companyid {*企业Id} companyid
 * @updateTopFn {*获取未读信息总数的方法} updateTopFn
 * @getInformOutLines {*获取信息未读数据的方法} getInformOutLines
 * @searchNotice {*获取信息列表的方法} searchNotice
 * @readedNotice {*清空数据的方法} readedNotice
 */
var Messages = function Messages(_ref) {
  var ny = _ref.ny,
      noticNum = _ref.noticNum,
      getNotice = _ref.getNotice,
      token = _ref.token,
      searchInitData = _ref.searchInitData,
      companyid = _ref.companyid,
      getInformOutLines = _ref.getInformOutLines,
      searchNotice = _ref.searchNotice,
      readedNotice = _ref.readedNotice;

  // console.log(token, '1111');
  return React.createElement(
    _Popover,
    {
      overlayClassName: 'popover-msg'
      // trigger="click"
      , content: React.createElement(NoticeInfoAlert, {
        token: token,
        searchInitData: searchInitData,
        companyid: companyid,
        updateTopFn: getNotice,
        getInformOutLines: getInformOutLines,
        searchNotice: searchNotice,
        readedNotice: readedNotice
      })
    },
    React.createElement(
      'div',
      { style: { marginRight: 10 }, className: 'noticeBrade' },
      React.createElement(
        _Badge,
        { dot: noticNum > 0 },
        React.createElement('img', {
          src: msgImg,
          alt: '\u6D88\u606F\u4E2D\u5FC3',
          title: '\u6D88\u606F\u4E2D\u5FC3',
          style: { width: 24, position: 'relative', top: -2 }
        })
      )
    )
  );
};

/**
 * 信息弹出窗口
 * @token {*用户token} token
 * @companyid {*企业Id} companyid
 * @updateTopFn {*获取未读信息总数的方法} updateTopFn
 * @getInformOutLines {*获取信息未读数据的方法} getInformOutLines
 * @searchNotice {*获取信息列表的方法} searchNotice
 * @readedNotice {*清空数据的方法} readedNotice
 */
var NoticeInfoAlert = function NoticeInfoAlert(_ref2) {
  var token = _ref2.token,
      searchInitData = _ref2.searchInitData,
      companyid = _ref2.companyid,
      updateTopFn = _ref2.updateTopFn,
      getInformOutLines = _ref2.getInformOutLines,
      searchNotice = _ref2.searchNotice,
      readedNotice = _ref2.readedNotice;

  console.log(searchInitData, '查询组件');

  var _useState = useState(_extends({}, searchInitData, {
    token: token
  })),
      _useState2 = _slicedToArray(_useState, 2),
      searchData = _useState2[0],
      setSearchData = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      infoData = _useState4[0],
      setInfoData = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      noticeTotal = _useState6[0],
      setNoticeTotal = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      system = _useState8[0],
      setSystem = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      message = _useState10[0],
      setMessage = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      todo = _useState12[0],
      setTodo = _useState12[1];

  var getNoticeList = function getNoticeList(os) {
    getInformOutLines(os || searchData).then(function (data) {
      setNoticeTotal(data);
      setSystem(data.systemInforms);
      setMessage(data.messageInforms);
      setTodo(data.todoInforms);
    });
  };
  useEffect(function () {
    getNoticeList();
  }, []);
  // 获取消息列表
  var getNoticeLists = function getNoticeLists(os) {
    searchNotice(os || searchData).then(function (data) {
      console.log(data);
      setInfoData(data.content);
    });
  };
  useEffect(function () {
    getNoticeLists();
  }, [searchData]);
  // 读取切换
  function callbackRead(key) {
    setSearchData(_extends({}, searchInitData, { informType: key }));
  }
  // 根据时间判断状态
  var getTimeDomFn = function getTimeDomFn(tag, all) {
    var timestamp = new Date().getTime();
    var startTimes = new Date(all.startTime).getTime();
    var endTime = new Date(all.endTime).getTime();
    var dom = 1;
    if (all.customerTag) {
      dom = React.createElement(
        _Tag,
        { color: 'orange' },
        tag
      );
    } else {
      if (startTimes < timestamp) {
        dom = React.createElement(
          _Tag,
          { color: 'grey' },
          '\u672A\u5F00\u59CB'
        );
      }
      if (endTime <= timestamp) {
        dom = React.createElement(
          _Tag,
          { color: 'grey' },
          '\u5DF2\u7ED3\u675F'
        );
      }
      if (startTimes <= timestamp < 0.67 * (endTime - startTimes)) {
        dom = React.createElement(
          _Tag,
          { color: 'blue' },
          '\u8FDB\u884C\u4E2D'
        );
      }
      if (0.67 * (endTime - startTimes) <= timestamp < endTime) {
        dom = React.createElement(
          _Tag,
          { color: 'red' },
          '\u9A6C\u4E0A\u5230\u671F'
        );
      }
    }
    return dom;
  };
  // 已读
  var empty = function empty() {
    var infoIds = infoData.map(function (j) {
      return j.id;
    });
    // console.log(infoIds);
    readedNotice(infoIds).then(function (data) {
      getNoticeList();
      getNoticeLists();
      updateTopFn();
    });
  };
  // 信息dom
  var getNoticeDom = function getNoticeDom(type) {
    // 中间内容
    var sp = null;
    // 查看更多地址
    var footAddress = (ny ? dyDomainNy : dyDomainCity) + '/user/notice/sys?token=' + token + '&companyid=' + companyid;
    if (type === 1) {
      sp = React.createElement(
        'ul',
        { style: { listStyleType: 'none' } },
        system.length === 0 ? React.createElement(
          'div',
          { className: 'noData' },
          React.createElement(_Empty, null)
        ) : system && system.map(function (i) {
          return React.createElement(
            'li',
            null,
            React.createElement(
              'h3',
              null,
              i.title
            ),
            React.createElement(
              'p',
              { className: 'gray' },
              renderTime(i.createdAt)
            )
          );
        })
      );
      footAddress = (ny ? dyDomainNy : dyDomainCity) + '/user/notice/sys?token=' + token + '&companyid=' + companyid;
    }
    if (type === 2) {
      sp = React.createElement(
        'ul',
        { style: { listStyleType: 'none' } },
        message.length === 0 ? React.createElement(
          'div',
          { className: 'noData' },
          React.createElement(_Empty, null)
        ) : message && message.map(function (i) {
          return React.createElement(
            'li',
            null,
            React.createElement(
              'h3',
              null,
              i.title
            ),
            React.createElement(
              'p',
              { className: 'gray' },
              renderTime(i.createdAt)
            )
          );
        })
      );
      // footAddress = '/user/notice/message';
      footAddress = (ny ? dyDomainNy : dyDomainCity) + '/user/notice/message?token=' + token + '&companyid=' + companyid;
    }
    if (type === 3) {
      sp = React.createElement(
        'ul',
        { style: { listStyleType: 'none' } },
        todo.length === 0 ? React.createElement(
          'div',
          { className: 'noData' },
          React.createElement(_Empty, null)
        ) : todo && todo.map(function (i) {
          return React.createElement(
            'li',
            null,
            React.createElement(
              'h3',
              null,
              i.title
            ),
            React.createElement(
              'p',
              { className: 'gray' },
              renderTime(i.createdAt)
            )
          );
        })
      );
      // footAddress = '/user/notice/dealt';
      footAddress = (ny ? dyDomainNy : dyDomainCity) + '/user/notice/dealt?token=' + token + '&companyid=' + companyid;
    }
    // const finnalAdds = companyid
    //   ? footAddress + `?companyid=${companyid}`
    //   : footAddress;

    var oDom = React.createElement(
      'div',
      { className: 'innerSBox' },
      React.createElement(
        'div',
        { className: 'inner' },
        sp
      ),
      React.createElement(
        'div',
        { className: 'foot' },
        React.createElement(
          'a',
          { onClick: empty },
          '\u6E05\u7A7A'
        ),
        React.createElement(
          Link,
          {
            onClick: function onClick() {
              window.location.href = footAddress;
            }
          },
          '\u67E5\u770B\u66F4\u591A'
        )
      )
    );
    return oDom;
  };

  return React.createElement(
    'div',
    _defineProperty({
      className: 'noticeInfoBox'
    }, 'className', cx({
      noticeInfoBox: true,
      noticeInfoBoxny: process.env.REACT_APP_TYPE === 'ny'
    })),
    React.createElement(
      _Tabs,
      { defaultActiveKey: 'SYSTEM_INFORM', centered: true, onChange: callbackRead },
      React.createElement(
        TabPane,
        {
          tab: React.createElement(
            _Badge,
            { count: noticeTotal.systemInformsCount, offset: [10, 8] },
            React.createElement(
              'p',
              null,
              '\u7CFB\u7EDF\u901A\u77E5'
            )
          ),
          key: 'SYSTEM_INFORM'
        },
        getNoticeDom(1)
      ),
      React.createElement(
        TabPane,
        {
          tab: React.createElement(
            _Badge,
            { count: noticeTotal.messageInformsCount, offset: [10, 7] },
            React.createElement(
              'p',
              null,
              '\u6D88\u606F\u901A\u77E5'
            )
          ),
          key: 'MESSAGE_INFORM'
        },
        getNoticeDom(2)
      ),
      React.createElement(
        TabPane,
        {
          tab: React.createElement(
            _Badge,
            { count: noticeTotal.todoInformsCount, offset: [10, 7] },
            React.createElement(
              'p',
              null,
              '\u5F85\u529E\u901A\u77E5'
            )
          ),
          key: 'TODO_INFORM'
        },
        getNoticeDom(3)
      )
    )
  );
};

__signature__(NoticeInfoAlert, 'useState{[searchData, setSearchData]({\n    // informType: "SYSTEM_INFORM",\n    // status: "NOT_READ",\n    // serviceType: null,\n    // page: 0,\n    // size: 5,\n    ...searchInitData,\n    token,\n  })}\nuseState{[infoData, setInfoData]([])}\nuseState{[noticeTotal, setNoticeTotal]({})}\nuseState{[system, setSystem]([])}\nuseState{[message, setMessage]([])}\nuseState{[todo, setTodo]([])}\nuseEffect{}\nuseEffect{}');

var _default = Messages;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TabPane, 'TabPane', 'src/components/NavMsg.js');
  reactHotLoader.register(renderTime, 'renderTime', 'src/components/NavMsg.js');
  reactHotLoader.register(Messages, 'Messages', 'src/components/NavMsg.js');
  reactHotLoader.register(NoticeInfoAlert, 'NoticeInfoAlert', 'src/components/NavMsg.js');
  reactHotLoader.register(_default, 'default', 'src/components/NavMsg.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();